export default "__VITE_ASSET__CVk33D5v__"